module.exports = __webpack_public_path__ + "static/media/fwbz2_en.493ce59f.png";